/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Welcome_Banner_TextInputs */

const en_company_welcome_banner_text = /** @type {(inputs: Company_Welcome_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to the Matching Week! Please complete your company information now. Afterwards, you can create individual job postings.`)
};

const de_company_welcome_banner_text = /** @type {(inputs: Company_Welcome_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schön, dass Sie bei der Matching Week dabei sind. Bitte ergänzen Sie jetzt weitere Informationen zu Ihrem Unternehmen. Anschließend können Sie einzelne Stellenausschreibungen anlegen.`)
};

/**
* | output |
* | --- |
* | "Welcome to the Matching Week! Please complete your company information now. Afterwards, you can create individual job postings." |
*
* @param {Company_Welcome_Banner_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_welcome_banner_text = /** @type {((inputs?: Company_Welcome_Banner_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Welcome_Banner_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_welcome_banner_text(inputs)
	return en_company_welcome_banner_text(inputs)
});